import axios from 'axios';
import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_ORDERS_API_URL;
const baseB2bUrl = Config.MS_B2B_API_URL;

export const getLoyaltyCustomers = (params = {}) => {
  return axios.get(`${baseUrl}/loyalty-point-transactions`, params);
};

export const postLoyaltyCustomers = (payload = {}) => {
  return axios.post(`${baseUrl}/loyalty-point-transactions`, payload);
};

export const getLoyaltyCustomersCount = (params = {}) => {
  return axios.get(`${baseUrl}/loyalty-point-transactions/count`, params);
};

export const getCustomerId = (id) => {
  return axios.get(`${baseUrl}/customers/${id}`);
};

export const updateCustomerById = (id, payload) => {
  return axios.put(`${baseUrl}/customers/${id}`, payload);
};

export const getLoyaltyRules = (params = {}) => {
  return axios.get(`${baseUrl}/loyalty-point-rules`, params);
};

export const getLoyaltyRulesById = (id) => {
  return axios.get(`${baseUrl}/loyalty-point-rules/${id}`);
};

export const getLoyaltyRulesCount = (params = {}) => {
  return axios.get(`${baseUrl}/loyalty-point-rules/count`, params);
};

export const createLoyaltyRules = (payload = {}) => {
  return axios.post(`${baseUrl}/loyalty-point-rules`, payload);
};

export const updateLoyaltyRules = (id, payload = {}) => {
  return axios.put(`${baseUrl}/loyalty-point-rules/${id}`, payload);
};

export const deleteLoyaltyRules = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/loyalty-point-rules/${id}`, payload);
};

const getWarehouse = (params = {}) => {
  return axios.get(`${baseUrl}/warehouse`, params);
};

const getLoyaltyTransactionDetail = (id) => {
  return axios.get(`${baseUrl}/loyalty-point-transactions/${id}`);
};

const updateLoyaltyPointStatus = (id, status) => {
  return axios.put(
    `${baseUrl}/loyalty-point-transactions/${id}/state/${status}`,
  );
};

const getSalesOrder = (params = {}) => {
  return axios.get(`${baseUrl}/orders`, params);
};

export const getSalesOrderCount = (params = {}) => {
  return axios.get(`${baseUrl}/orders/count`, params);
};

const getSalesOrderDetail = (id) => {
  return axios.get(`${baseUrl}/orders/${id}`);
};

const updateReasonCancelled = (id, payload = {}) => {
  return axios.put(`${baseUrl}/orders/${id}/reason-cancelled`, payload);
};

const getSalesOrderInvoiceDelivery = (id) => {
  return axios.get(`${baseUrl}/delivery-invoice/${id}`);
};

const getReturnOrder = (params = {}) => {
  return axios.get(`${baseUrl}/return-orders`, params);
};

const getReturnOrderDetail = (id) => {
  return axios.get(`${baseUrl}/return-orders/${id}/`);
};

export const getReturnOrderCount = (params = {}) => {
  return axios.get(`${baseUrl}/return-orders/count`, params);
};

const checkOrderProductOos = (id) => {
  return axios.get(`${baseUrl}/orders/${id}/validate-out-of-stock-products`);
};

const checkOrderProductReturn = (id) => {
  return axios.get(
    `${baseUrl}/return-orders/${id}/validate-out-of-stock-products`,
  );
};

const syncOrderProductOos = (id) => {
  return axios.post(
    `${baseUrl}/orders/${id}/sync-products-qty-with-available-stocks`,
  );
};

const syncOrderReturnProductOos = (id) => {
  return axios.post(
    `${baseUrl}/orders/${id}/sync-products-qty-with-available-stocks`,
  );
};

const SourceDocReturn = (params = {}) => {
  return axios.get(`${baseUrl}/orders`, params);
};

const createSalesOrder = (payload = {}) => {
  return axios.post(`${baseUrl}/orders`, payload);
};

const duplicateSalesOrder = (id, payload = {}) => {
  return axios.post(`${baseUrl}/orders/${id}/duplicate`, payload);
};

const updateSalesOrder = (id, payload = {}) => {
  return axios.put(`${baseUrl}/orders/${id}`, payload);
};

const deleteSalesOrder = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/orders/${id}`, payload);
};

const updateSalesOrderStatus = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/orders/${id}/${status}`, payload);
};

const updateReturnOrderStatus = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/return-orders/${id}/status/${status}`, payload);
};

const exportSalesOrder = (id) => {
  return axios.post(`${baseUrl}/orders/${id}/pdf`);
};

const getPromotionRules = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules`, params);
};

const getPromotionRulesCount = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules/count`, params);
};

const getPromotionRulesDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules/${id}`, params);
};

const getRegularDiscount = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules/regular-discount`, params);
};

const getCashBeforeDelivery = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules/cash-before-delivery`, params);
};

const getExtraDiscount = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-rules/extra-discount`, params);
};

const createPromotionRules = (payload = {}) => {
  return axios.post(`${baseUrl}/promotion-rules`, payload);
};

const updatePromotionRules = (id, payload = {}) => {
  return axios.put(`${baseUrl}/promotion-rules/${id}`, payload);
};

const updatePromotionRulesStatus = (id, status, payload = {}) => {
  return axios.put(
    `${baseUrl}/promotion-rules/${id}/status/${status}`,
    payload,
  );
};

const deletePromotionRules = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/promotion-rules/${id}`, payload);
};

const exportPromotionRules = (payload = {}) => {
  return axios.post(`${baseB2bUrl}/promotion-rules/exports`, payload);
};

const exportDataPromotionRules = (type, payload = {}, params = {}) => {
  return axios.post(
    `${baseB2bUrl}/promotion-rules-${type}/exports`,
    payload,
    params,
  );
};

const duplicatePromotionRules = (id, payload = {}) => {
  return axios.post(`${baseUrl}/promotion-rules/${id}/duplicate`, payload);
};

const updatePriceRulesOrder = (id, pricelistId, payload = {}) => {
  return axios.put(
    `${baseUrl}/orders/${id}/pricelists/${pricelistId}`,
    payload,
  );
};

const createAttachmentOrder = (id, payload = {}) => {
  return axios.post(`${baseUrl}/orders/${id}/attachments`, payload);
};

const removeAttachmentOrder = (id, attachmentId, payload = {}) => {
  return axios.delete(
    `${baseUrl}/orders/${id}/attachments/${attachmentId}`,
    payload,
  );
};

const createAttachmentReturn = (id, payload = {}) => {
  return axios.put(`${baseUrl}/return-orders/${id}`, payload);
};

const removeAttachmentReturn = (id, attachmentId, payload = {}) => {
  return axios.delete(
    `${baseUrl}/return-orders/${id}/attachments/${attachmentId}`,
    payload,
  );
};

const updatePaymentProofOrder = (id, payload = {}) => {
  return axios.put(`${baseUrl}/orders/${id}/payment_proof`, payload);
};

const deletePaymentProofOrder = (id) => {
  return axios.delete(`${baseUrl}/orders/${id}/payment_proof`);
};

const getProductSalesOrder = (id, payload = {}) => {
  return axios.get(`${baseUrl}/orders/${id}/products`, payload);
};

const getAllProductSalesOrder = (id, payload = {}) => {
  return axios.get(`${baseUrl}/orders/${id}/products/all`, payload);
};

const getProductCountSalesOrder = (id = {}) => {
  return axios.get(`${baseUrl}/orders/${id}/products/count`);
};

const createReturnOrder = (payload = {}) => {
  return axios.post(`${baseUrl}/return-orders`, payload);
};

const updateReturnOrder = (id, payload = {}) => {
  return axios.put(`${baseUrl}/return-orders/${id}`, payload);
};

const getProductReturnOrder = (id, payload = {}) => {
  return axios.get(`${baseUrl}/return-orders/${id}/products`, payload);
};

const deleteReturnOrder = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/return-orders/${id}`, payload);
};

const removeProductSalesOrder = (
  id,
  productId,
  combinationId,
  payload = {},
) => {
  return axios.delete(
    `${baseUrl}/orders/${id}/products/${productId}/combinations/${combinationId}`,
    payload,
  );
};

const createProductSalesOrder = (id, payload = {}) => {
  return axios.put(`${baseUrl}/orders/${id}/products`, payload);
};

const updateProductSalesOrder = (id, payload = {}) => {
  return axios.put(
    `${baseUrl}/orders/${id}/products/${payload.id}/combinations/${payload.combination_id}`,
    payload,
  );
};

const updateStatusActivePromotionRules = (id, payload = {}) => {
  return axios.put(`${baseUrl}/promotion-rules/${id}/state`, payload);
};

const checkPromotionBudget = (payload = {}) => {
  return axios.post(`${baseUrl}/orders/validate-budget-pocket-amount`, payload);
};

const checkPromotion = (payload = {}) => {
  return axios.post(`${baseUrl}/orders/validate-promo-applied`, payload);
};

const assignPromotionBudget = (id, promotionId, payload = {}) => {
  return axios.put(
    `${baseUrl}/orders/${id ? id : 'new'}/promotions/${promotionId}`,
    payload,
  );
};

const resetPromotionBudget = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/orders/${id ? id : 'new'}/reset-extra-discount`,
    payload,
  );
};

const createPromoProductSalesOrder = (id, promotionId, payload = {}) => {
  return axios.put(
    `${baseUrl}/orders/${id}/promotions/${promotionId}`,
    payload,
  );
};

const validatePromotionRules = (id, promotionId, payload = {}) => {
  return axios.put(
    `${baseUrl}/orders/${id}/promotions/${promotionId}/validate`,
    payload,
  );
};

const removePromoProductSalesOrder = (
  id,
  promotionId,
  productId,
  combinationId,
  payload = {},
) => {
  return axios.delete(
    `${baseUrl}/orders/${id}/promotions/${promotionId}/products/${productId}/combinations/${combinationId}`,
    payload,
  );
};

const getProductPromotion = (id, productId, combinationId, payload = {}) => {
  return axios.get(
    `${baseUrl}/orders/${id}/products/${productId}/combinations/${combinationId}/promo-reminders`,
    payload,
  );
};

const getEstimationOrder = (productId, combinationId, payload = {}) => {
  return axios.get(
    `${baseUrl}/orders/products/${productId}/combinations/${combinationId}/estimation-order`,
    payload,
  );
};

const getBudgetPocket = (params = {}) => {
  return axios.get(`${baseUrl}/budget-pockets`, params);
};

const getBudgetPocketCount = (params = {}) => {
  return axios.get(`${baseUrl}/budget-pockets/count`, params);
};

const getBudgetPocketDetail = (id) => {
  return axios.get(`${baseUrl}/budget-pockets/${id}`);
};

const createBudgetPocket = (payload = {}) => {
  return axios.post(`${baseUrl}/budget-pockets`, payload);
};

const updateBudgetPocket = (id, payload = {}) => {
  return axios.put(`${baseUrl}/budget-pockets/${id}`, payload);
};

const deleteBudgetPocket = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/budget-pockets/${id}`, payload);
};

const transferBudget = (id, payload = {}) => {
  return axios.post(`${baseUrl}/budget-pockets/${id}/transfer`, payload);
};

const getTransferBudgetHistories = (id, params = {}) => {
  return axios.get(`${baseUrl}/budget-pockets/${id}/transfer`, params);
};

const getTransferBudgetHistoriesCount = (id, params = {}) => {
  return axios.get(`${baseUrl}/budget-pockets/${id}/transfer/count`, params);
};

const changeStatusBudgetPocket = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/budget-pockets/${id}/status/${status}`, payload);
};

const updateStatusActiveBudgetPocket = (id, payload = {}) => {
  return axios.put(`${baseUrl}/budget-pockets/${id}/state`, payload);
};

const uploadBulkSalesOrderProduct = (id, payload = {}) => {
  return axios.post(`${baseUrl}/orders/${id}/products/bulk`, payload);
};

const getCoaTaxSettings = (params = {}) => {
  return axios.get(`${baseUrl}/coa-taxes`, params);
};

const getCoaTaxSettingsCount = (params = {}) => {
  return axios.get(`${baseUrl}/coa-taxes/count`, params);
};

const getCoaTaxSettingsDetail = (id) => {
  return axios.get(`${baseUrl}/coa-taxes/${id}`);
};

const createCoaTaxSettings = (payload = {}) => {
  return axios.post(`${baseUrl}/coa-taxes`, payload);
};

const updateCoaTaxSettings = (id, payload = {}) => {
  return axios.put(`${baseUrl}/coa-taxes/${id}`, payload);
};

const deleteCoaTaxSettings = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/coa-taxes/${id}`, payload);
};

const changeStatusCoaTaxSettings = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/coa-taxes/${id}/status/${status}`, payload);
};

const getSkpExternal = (params = {}) => {
  return axios.get(`${baseUrl}/skp-externals`, params);
};

const getSkpExternalCount = (params = {}) => {
  return axios.get(`${baseUrl}/skp-externals/count`, params);
};

const checkSkpExternalCalculation = (payload = {}) => {
  return axios.post(`${baseUrl}/skp-externals/check-calculation`, payload);
};

const getSkpExternalDetail = (id) => {
  return axios.get(`${baseUrl}/skp-externals/${id}`);
};

const createSkpExternal = (payload = {}) => {
  return axios.post(`${baseUrl}/skp-externals`, payload);
};

const updateSkpExternal = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}`, payload);
};

const updateOnlySkpExternal = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}/preview`, payload);
};

const deleteSkpExternal = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/skp-externals/${id}`, { data: payload });
};

const changeStatusSkpExternal = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}/status/${status}`, payload);
};

const exportSkpExternals = (id) => {
  return axios.post(`${baseUrl}/skp-externals/${id}/pdf`);
};

const generateSkpExternals = (id) => {
  return axios.post(`${baseUrl}/skp-externals/${id}/generate`);
};

const getSkpExternalLogs = (id, params) => {
  return axios.get(`${baseUrl}/skp-externals/${id}/logs`, { params });
};

const getLpbCarrier = (params = {}) => {
  return axios.get(`${baseUrl}/lpb/carrier`, params);
};

const get3plLpb = (params = {}) => {
  return axios.get(`${baseUrl}/lpb`, params);
};

const get3plLpbCount = (params = {}) => {
  return axios.get(`${baseUrl}/lpb/count`, params);
};

const get3plLpbDetail = (id) => {
  return axios.get(`${baseUrl}/lpb/${id}`);
};

const create3plLpb = (payload = {}) => {
  return axios.post(`${baseUrl}/lpb`, payload);
};

const update3plLpb = (id, payload = {}) => {
  return axios.put(`${baseUrl}/lpb/${id}`, payload);
};

const changeStatus3plLpb = (id, status, payload) => {
  return axios.put(`${baseUrl}/lpb/${id}/status/${status}`, payload);
};

const update3plLpbDocument = (id, payload = {}) => {
  return axios.put(`${baseUrl}/lpb/${id}/document`, payload);
};

const delete3plLpbDocument = (id, type) => {
  return axios.delete(`${baseUrl}/lpb/${id}/document/${type}`);
};

const updateLpbAttachment = (id, payload = {}) => {
  return axios.put(`${baseUrl}/lpb/${id}/documents`, payload);
};

const deleteLpbAttachmentByUrl = (id, payload = {}) => {
  return axios.put(`${baseUrl}/lpb/${id}/documents-delete`, payload);
};

const getLpbLogs = (id, params) => {
  return axios.get(`${baseUrl}/lpb/${id}/logs`, { params });
};

const getLpbSummary = (params = {}) => {
  return axios.get(`${baseUrl}/lpb/summary`, { params });
};

const getSkpInternal = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internals`, params);
};

const getSkpInternalCount = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internals/count`, params);
};

const getSkpInternalDetail = (id) => {
  return axios.get(`${baseUrl}/skp-internals/${id}`);
};

const createSkpInternal = (payload = {}) => {
  return axios.post(`${baseUrl}/skp-internals`, payload);
};

const updateSkpInternal = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-internals/${id}`, payload);
};

const deleteSkpInternal = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/skp-internals/${id}`, payload);
};

const changeStatusSkpInternal = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/skp-internals/${id}/status/${status}`, payload);
};

const uploadListCustomerBrandBudget = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/skp-internal-customer-brands/${id}/bulk`,
    payload,
  );
};

const getSkpInternalsBrandBudget = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customer-brands`, params);
};

const getAllSkpInternalsBrandBudget = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customer-brands/all`, params);
};

const getSkpInternalsBrandBudgetCount = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customer-brands/count`, params);
};

const getSkpInternalsBrandBudgetDetail = (id) => {
  return axios.get(`${baseUrl}/skp-internal-customer-brands/${id}`);
};

const createSkpInternalsBrandBudget = (payload = {}) => {
  return axios.post(`${baseUrl}/skp-internal-customer-brands`, payload);
};

const updateSkpInternalsBrandBudget = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-internal-customer-brands/${id}`, payload);
};

const deleteSkpInternalsBrandBudget = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/skp-internal-customer-brands/${id}`, payload);
};

const getSkpInternalsBrandBudgetLogs = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customer-brands/logs`, params);
};

const getSkpInternalsBrandBudgetLogsCount = (params = {}) => {
  return axios.get(
    `${baseUrl}/skp-internal-customer-brands/logs/count`,
    params,
  );
};

const updateStatusActiveSkpInternal = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-internals/${id}/state`, payload);
};

const getSkpInternalLogs = (id, params) => {
  return axios.get(`${baseUrl}/skp-internals/${id}/logs`, { params });
};

const updateStatusActiveSkpExternal = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}/state`, payload);
};

const getSkpExternalsBrandBudget = (params = {}) => {
  return axios.get(`${baseUrl}/skp-external-customer-brands`, params);
};

const getAllSkpExternalsBrandBudget = (params = {}) => {
  return axios.get(`${baseUrl}/skp-external-customer-brands/all`, params);
};

const updateSkpExternalsBrandBudget = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-external-customer-brands/${id}`, payload);
};

const createSkpExternalsBrandBudgetBulk = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/skp-external-customer-brands/${id}/bulk`,
    payload,
  );
};

const calculateSkpInternalsBrandBudgetBulk = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/skp-internal-customer-brands/${id}/calculate`,
    payload,
  );
};

const getSkpInternalCustomers = (id, params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customers/${id}`, params);
};

const getSkpInternalCustomersCount = (id, params = {}) => {
  return axios.get(`${baseUrl}/skp-internal-customers/${id}/count`, params);
};

const updateSkpExternalAttachment = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}/documents`, payload);
};

const updateSkpInternalAttachment = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-internal/${id}/documents`, payload);
};

const deleteSkpExternalAttachment = (id, type, payload = {}) => {
  return axios.delete(
    `${baseUrl}/skp-externals/${id}/documents/${type}`,
    payload,
  );
};

const deleteSkpExternalAttachmentByUrl = (id, payload = {}) => {
  return axios.put(`${baseUrl}/skp-externals/${id}/documents-delete`, payload);
};

const deleteSkpInternalAttachment = (id, payload) => {
  return axios.put(`${baseUrl}/skp-internal/${id}/documents-delete`, payload);
};

const getInventory = (params = {}) => {
  return axios.get(`${baseUrl}/inventory`, params);
};

const getInventoryCount = (params = {}) => {
  return axios.get(`${baseUrl}/inventory/count`, params);
};

const getInventoryDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/inventory/${id}`, params);
};

const createInventory = (payload = {}) => {
  return axios.post(`${baseUrl}/inventory`, payload);
};

const updateInventory = (id, payload = {}) => {
  return axios.put(`${baseUrl}/inventory/${id}`, payload);
};

const calculateInventoryStock = (payload) => {
  return axios.put(`${baseUrl}/inventory/stock`, payload);
};

const updateInventoryStatus = (id, status, payload) => {
  return axios.put(`${baseUrl}/inventory/${id}/status/${status}`, payload);
};

const deleteInventory = (id) => {
  return axios.delete(`${baseUrl}/inventory/${id}`);
};

const deleteInventoryProduct = (id, product_id, combination_id) => {
  return axios.delete(
    `${baseUrl}/inventory/${id}/product/${product_id}/combination/${combination_id}`,
  );
};

const getInventorySummary = (params = {}) => {
  return axios.get(`${baseUrl}/inventory/summary`, params);
};

const getInventorySummaryCount = (params = {}) => {
  return axios.get(`${baseUrl}/inventory/summary/count`, params);
};

const getSalesmanProducts = (id, params) => {
  return axios.get(`${baseUrl}/inventory/summary/${id}/products`, params);
};

const getSalesmanProductsCount = (id, params) => {
  return axios.get(`${baseUrl}/inventory/summary/${id}/products/count`, params);
};

const getSalesmanLogs = (id, params) => {
  return axios.get(`${baseUrl}/inventory/summary/${id}/logs`, params);
};

const getSalesmanLogsCount = (id, params) => {
  return axios.get(`${baseUrl}/inventory/summary/${id}/logs/count`, params);
};

const exportForecastStock = (params = {}) => {
  return axios.post(`${baseUrl}/forecast-stock`, params);
};

export const getForecastSalesTeam = (params = {}) => {
  return axios.get(`${baseUrl}/forecast-stock/sales-team`, params);
};

export const getForecastSalesTeamCount = (params = {}) => {
  return axios.get(`${baseUrl}/forecast-stock/sales-team/count`, params);
};

export const getForecastBySalesTeam = (params = {}, id) => {
  return axios.get(`${baseUrl}/forecast-stock/sales-team/${id}`, params);
};

export const getForecastBySalesTeamCount = (params = {}, id) => {
  return axios.get(`${baseUrl}/forecast-stock/sales-team/${id}/count`, params);
};

export const uploadForecaseEstimation = (id, payload = {}) => {
  return axios.put(
    `${baseUrl}/forecast-stock/sales-team/${id}/upload`,
    payload,
  );
};

export const updateForecastRow = (id, product_id, payload = {}) => {
  return axios.put(
    `${baseUrl}/forecast-stock/sales-team/${id}/product/${product_id}`,
    payload,
  );
};

export const deleteForecaseEstimation = (id, year) => {
  return axios.delete(
    `${baseUrl}/forecast-stock/sales-team/${id}/year/${year}`,
  );
};

export const updateOrderSignaturesById = (id, payload) => {
  return axios.put(`${baseUrl}/orders/${id}/signatures/update`, payload);
};

export const importSo = (payload) => {
  return axios.post(`${baseUrl}/orders/import`, payload);
};

export const getRequestProductPeriod = (params = {}) => {
  return axios.get(`${baseUrl}/request-product-periods`, params);
};

export const getRequestProductPeriodCount = (params = {}) => {
  return axios.get(`${baseUrl}/request-product-periods/count`, params);
};

export const createRequestProductPeriod = (payload = {}) => {
  return axios.post(`${baseUrl}/request-product-periods`, payload);
};

export const updateRequestProductPeriod = (id, payload = {}) => {
  return axios.put(`${baseUrl}/request-product-periods/${id}`, payload);
};

export const getProductListing = (params = {}) => {
  return axios.get(`${baseUrl}/request-product-eligibilities`, params);
};

export const getProductListingCount = (params = {}) => {
  return axios.get(`${baseUrl}/request-product-eligibilities/count`, params);
};

export const getProductListingDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/request-product-eligibilities/${id}`, params);
};

export const createProductListing = (payload = {}) => {
  return axios.post(`${baseUrl}/request-product-eligibilities`, payload);
};

export const updateProductListing = (id, payload = {}) => {
  return axios.put(`${baseUrl}/request-product-eligibilities/${id}`, payload);
};

export const deleteProductListing = (id) => {
  return axios.delete(`${baseUrl}/request-product-eligibilities/${id}`);
};

export const importCreateProductListing = (payload = {}) => {
  return axios.post(
    `${baseUrl}/request-product-eligibilities/bulk/create`,
    payload,
  );
};

export const importActiveProductListing = (payload = {}) => {
  return axios.post(
    `${baseUrl}/request-product-eligibilities/bulk/update-product`,
    payload,
  );
};

export const getProductListingLog = (id, params = {}) => {
  return axios.get(`${baseUrl}/request-product-eligibilities/${id}/logs`, {
    params,
  });
};

export const getProductListingItems = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/request-product-eligibilities/${id}/products`,
    params,
  );
};

export const getProductListingItemsCount = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/request-product-eligibilities/${id}/products/count`,
    params,
  );
};

export const searchProductListingItems = (params = {}) => {
  return axios.get(`${baseUrl}/request-products/search/products`, params);
};

export const searchProductListingItemsCount = (params = {}) => {
  return axios.get(`${baseUrl}/request-products/search/products/count`, params);
};

export const getProductListingSummary = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/request-product-eligibilities/${id}/summary`,
    params,
  );
};

export const getProductListingSummaryLog = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/request-product-eligibilities/${id}/summary/log`,
    params,
  );
};

export const getProductListingSummaryLogCount = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/request-product-eligibilities/${id}/summary/log/count`,
    params,
  );
};

export const addProductListingItems = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/request-product-eligibilities/${id}/products`,
    payload,
  );
};

export const updateProductListingItems = (
  id,
  product_id,
  combination_id,
  payload = {},
) => {
  return axios.put(
    `${baseUrl}/request-product-eligibilities/${id}/products/${product_id}/combinations/${combination_id}`,
    payload,
  );
};

export const deleteProductListingItems = (
  id,
  product_id,
  combination_id,
  payload = {},
) => {
  return axios.delete(
    `${baseUrl}/request-product-eligibilities/${id}/products/${product_id}/combinations/${combination_id}`,
    payload,
  );
};

export const getRequestProductTesterLogs = (id, params = {}) => {
  return axios.get(`${baseUrl}/request-products/${id}/logs`, { params });
};

export const getRequestProductTester = (params = {}) => {
  return axios.get(`${baseUrl}/request-products`, params);
};

export const getRequestProductTesterCount = (params = {}) => {
  return axios.get(`${baseUrl}/request-products/count`, params);
};

export const getRequestProductTesterDetail = (id) => {
  return axios.get(`${baseUrl}/request-products/${id}`);
};

export const createRequestProductTester = (payload = {}) => {
  return axios.post(`${baseUrl}/request-products`, payload);
};

export const updateRequestProductTester = (id, payload = {}) => {
  return axios.put(`${baseUrl}/request-products/${id}`, payload);
};

export const deleteRequestProductTester = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/request-products/${id}`, { data: payload });
};

export const updateRequestProductStatus = (id, status, payload = {}) => {
  return axios.put(
    `${baseUrl}/request-products/${id}/status/${status}`,
    payload,
  );
};

export const updateRequestProductDeliveryConfirmation = (id, payload = {}) => {
  return axios.put(
    `${baseUrl}/request-products/${id}/delivery-confirmation`,
    payload,
  );
};

export const addProductToRequestProductTester = (id, payload = {}) => {
  return axios.post(`${baseUrl}/request-products/${id}/products`, payload);
};

export const getProductsFromRequestProductTester = (id, params = {}) => {
  return axios.get(`${baseUrl}/request-products/${id}/products`, params);
};

export const getProductsCountFromRequestProductTester = (id, params = {}) => {
  return axios.get(`${baseUrl}/request-products/${id}/products/count`, params);
};

export const deleteProductFromRequestProductTester = (
  id,
  product_id,
  combination_id,
) => {
  return axios.delete(
    `${baseUrl}/request-products/${id}/products/${product_id}/combinations/${combination_id}`,
  );
};

export const getProductStockSalesTeams = (params = {}) => {
  return axios.get(`${baseUrl}/product-stock/sales-teams`, params);
};

export const getProductStockSearch = (params = {}) => {
  return axios.get(`${baseUrl}/product-stock/search`, params);
};

export const getProductStockDetail = (skuId, params = {}) => {
  return axios.get(`${baseUrl}/product-stock/${skuId}/detail`, params);
};

export const MsOrder = {
  getLoyaltyCustomers,
  getWarehouse,
  getLoyaltyTransactionDetail,
  updateLoyaltyPointStatus,
  getSalesOrder,
  getSalesOrderCount,
  getSalesOrderDetail,
  getSalesOrderInvoiceDelivery,
  getReturnOrder,
  getReturnOrderCount,
  getReturnOrderDetail,
  createSalesOrder,
  duplicateSalesOrder,
  updateSalesOrder,
  deleteSalesOrder,
  updateSalesOrderStatus,
  updateReturnOrderStatus,
  exportSalesOrder,
  SourceDocReturn,
  deleteReturnOrder,
  checkOrderProductOos,
  checkOrderProductReturn,
  syncOrderProductOos,
  getPromotionRules,
  getPromotionRulesCount,
  getPromotionRulesDetail,
  getRegularDiscount,
  getCashBeforeDelivery,
  getExtraDiscount,
  createPromotionRules,
  updatePromotionRules,
  updatePromotionRulesStatus,
  deletePromotionRules,
  exportPromotionRules,
  exportDataPromotionRules,
  duplicatePromotionRules,
  updatePriceRulesOrder,
  createAttachmentOrder,
  removeAttachmentOrder,
  createAttachmentReturn,
  removeAttachmentReturn,
  getProductSalesOrder,
  getAllProductSalesOrder,
  getProductCountSalesOrder,
  createReturnOrder,
  updateReturnOrder,
  getProductReturnOrder,
  removeProductSalesOrder,
  createProductSalesOrder,
  updateProductSalesOrder,
  updateStatusActivePromotionRules,
  checkPromotionBudget,
  checkPromotion,
  assignPromotionBudget,
  resetPromotionBudget,
  createPromoProductSalesOrder,
  removePromoProductSalesOrder,
  getProductPromotion,
  getEstimationOrder,
  getBudgetPocket,
  getBudgetPocketCount,
  getBudgetPocketDetail,
  createBudgetPocket,
  updateBudgetPocket,
  deleteBudgetPocket,
  changeStatusBudgetPocket,
  updateStatusActiveBudgetPocket,
  uploadBulkSalesOrderProduct,
  syncOrderReturnProductOos,
  transferBudget,
  getTransferBudgetHistories,
  getTransferBudgetHistoriesCount,
  getCoaTaxSettings,
  getCoaTaxSettingsCount,
  getCoaTaxSettingsDetail,
  createCoaTaxSettings,
  updateCoaTaxSettings,
  deleteCoaTaxSettings,
  changeStatusCoaTaxSettings,
  getSkpExternal,
  getSkpExternalCount,
  checkSkpExternalCalculation,
  getSkpExternalDetail,
  createSkpExternal,
  updateSkpExternal,
  updateOnlySkpExternal,
  deleteSkpExternal,
  changeStatusSkpExternal,
  getLpbCarrier,
  get3plLpb,
  get3plLpbCount,
  get3plLpbDetail,
  create3plLpb,
  update3plLpb,
  changeStatus3plLpb,
  update3plLpbDocument,
  delete3plLpbDocument,
  updateLpbAttachment,
  deleteLpbAttachmentByUrl,
  getLpbLogs,
  getLpbSummary,
  getSkpInternal,
  getSkpInternalsBrandBudget,
  getAllSkpInternalsBrandBudget,
  getSkpInternalDetail,
  exportSkpExternals,
  getSkpInternalCount,
  createSkpInternal,
  updateSkpInternal,
  deleteSkpInternal,
  changeStatusSkpInternal,
  getSkpInternalsBrandBudgetCount,
  getSkpInternalsBrandBudgetDetail,
  createSkpInternalsBrandBudget,
  updateSkpInternalsBrandBudget,
  deleteSkpInternalsBrandBudget,
  getSkpInternalsBrandBudgetLogs,
  getSkpInternalsBrandBudgetLogsCount,
  uploadListCustomerBrandBudget,
  updateStatusActiveSkpInternal,
  getSkpInternalLogs,
  updateStatusActiveSkpExternal,
  getSkpExternalsBrandBudget,
  getAllSkpExternalsBrandBudget,
  updateSkpExternalsBrandBudget,
  createSkpExternalsBrandBudgetBulk,
  calculateSkpInternalsBrandBudgetBulk,
  getSkpInternalCustomers,
  getSkpInternalCustomersCount,
  generateSkpExternals,
  getSkpExternalLogs,
  updateSkpExternalAttachment,
  updateSkpInternalAttachment,
  deleteSkpExternalAttachment,
  deleteSkpInternalAttachment,
  deleteSkpExternalAttachmentByUrl,
  getInventory,
  getInventoryCount,
  getInventoryDetail,
  createInventory,
  updateInventory,
  calculateInventoryStock,
  updateInventoryStatus,
  deleteInventory,
  deleteInventoryProduct,
  getInventorySummary,
  getInventorySummaryCount,
  getSalesmanProducts,
  getSalesmanProductsCount,
  getSalesmanLogs,
  getSalesmanLogsCount,
  exportForecastStock,
  getForecastSalesTeam,
  getForecastSalesTeamCount,
  getForecastBySalesTeam,
  getForecastBySalesTeamCount,
  uploadForecaseEstimation,
  updateForecastRow,
  deleteForecaseEstimation,
  updateReasonCancelled,
  updateOrderSignaturesById,
  importSo,
  updatePaymentProofOrder,
  deletePaymentProofOrder,
  validatePromotionRules,
  getRequestProductPeriod,
  getRequestProductPeriodCount,
  createRequestProductPeriod,
  updateRequestProductPeriod,
  getProductListing,
  getProductListingCount,
  getProductListingDetail,
  createProductListing,
  updateProductListing,
  importCreateProductListing,
  importActiveProductListing,
  getProductListingLog,
  getProductListingItems,
  getProductListingItemsCount,
  searchProductListingItems,
  searchProductListingItemsCount,
  getProductListingSummary,
  getProductListingSummaryLog,
  getProductListingSummaryLogCount,
  addProductListingItems,
  updateProductListingItems,
  deleteProductListing,
  deleteProductListingItems,
  getRequestProductTesterLogs,
  getRequestProductTester,
  getRequestProductTesterCount,
  getRequestProductTesterDetail,
  createRequestProductTester,
  updateRequestProductTester,
  deleteRequestProductTester,
  updateRequestProductStatus,
  updateRequestProductDeliveryConfirmation,
  addProductToRequestProductTester,
  getProductsFromRequestProductTester,
  getProductsCountFromRequestProductTester,
  deleteProductFromRequestProductTester,
  getProductStockSalesTeams,
  getProductStockSearch,
  getProductStockDetail,
};
